function ButtonLink({ link = "#", caption = "not set", star = "false" }) {
  return (
    <div className="row py-2">
      <a className="btn text-light btn-success" href={link}>
        {star && <span class="me-2">🌟</span>}
        {caption}
      </a>
    </div>
  );
}

export default ButtonLink;
